export default {
  planningMapView: {
    baseMap: "Bản đồ nền",
    toolsMap: "Công cụ bản đồ",
    googleMap: "Bản đồ Google",
    satelliteMap: "Bản đồ vệ tinh",
    notUseBaseMap: "Không dùng bản đồ nền",
    mapToolsPanel: {
      viewObjectInfomation: "Xem thông tin đối tượng",
      toggleFullScreen: "Mở rộng/Thu nhỏ",
      zoomIn: "Phóng to bản đồ",
      zoomOut: "Thu nhỏ bản đồ",
      filterInfomation: "Lọc thông tin",
      mapLegend: "Chú giải bản đồ",
      selectAnObject: "Chọn một đối tượng",
      selectMultiObject: "Chọn nhiều đối tượng",
      measuareArea: "Đo diện tích",
      measuareDistance: "Đo khoảng cách",
      moveViewport: "Di chuyển khung nhìn",
      printTheMap: "In bản đồ",
      myPosition: "Xác định vị trí của bạn",
      exportMap: "Xuất bản đồ",
      compare: "So sánh",
      locationMarker: "Đánh dấu vị trí",
      mapReport: "Báo cáo",
      faq: "Câu hỏi thường gặp",
    },
    filterInfomationPopup: {
      headTitle: "Tìm kiếm đối tượng",
      labelSelectSearch: "Chọn đối tượng tìm kiếm",
      searchInLine: "Tìm kiếm trên đường",
      searchInArea: "Tìm kiếm trong vùng",
      searchInCircle: "TÌm kiếm trong đường tròn",
      searchInSquare: "Tìm kiếm trong hình chữ nhật",
      searchWithAttribute: "Theo thuộc tính",
      search: "Tìm kiếm",
      delete: "Xóa",
      close: "Đóng",
    },
  },
  planningMapView_guideToUse: "Hướng dẫn sử dụng",
  planningMapView_guideToUse_category: "Danh mục hướng dẫn",
  planningMapView_map: "Bản đồ",
  planningMapView_infomation: "Thông tin",
  planningMapView_relatedPlanning: "Quy hoạch liên quan",
  planningMapView_result: "Kết quả",
  header_homePage: "Trang chủ",
  header_pleaseConsultTheCommunity: "Xin ý kiến cộng đồng",
  header_lookUpPlanning: "Tra cứu quy hoạch",
  header_news: "Tin tức",
  header_planningAnnouncement: "Công bố quy hoạch",
  header_recordsManager: "Quản lý hồ sơ",
  header_Contact: "Liên hệ",
  header_generalPlanning: "Quy hoạch chung",
  header_syntheticPlanning: "Tổng hợp quy hoạch",
  header_subdivisionPlanning: "Quy hoạch phân khu",
  header_detailedPlanning: "Quy hoạch chi tiết",
  header_specializedPlanning: "Quy hoạch chuyên ngành",
  header_administration: "Quản trị",
  header_logout: "Đăng xuất",
  header_logIn: "Đăng Nhập",
  header_account: "Tài khoản",
  footer_titleName: "CÔNG TY CỔ PHẦN CÔNG NGHỆ CAO CTECH",
  footer_email: "c2tech.vn@gmail.com",
  footer_address: "Địa chỉ: Tầng 1, nhà E, Khu Vinaconex 1, số 289A Khuất Duy Tiến, Quận Cầu Giấy, TP. Hà Nội.",
  footer_hotline: "Điện thoại: 0968883898",
  footer_fax: "(0203).3838071",
  footer_copyright: "© Bản quyền thuộc về Công cty CTECH và Công ty ACUD Việt Nam",
  contact_hotline: "0968883898",
  contact_hotline_show: "0968883898",
  contact_fax: "0215.825.944",
  contact_email: "c2tech.vn@gmail.com",
  contact_website: "https://c2tech.vn/",
  contact_map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1857.4861243981127!2d103.01492464293781!3d21.390997324586692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x312d088a55555555%3A0x575405be2697b673!2zU-G7nyBL4bq_IGhv4bqhY2ggdsOgIMSQ4bqndSB0xrAgdOG7iW5oIMSQaeG7h24gQmnDqm4!5e0!3m2!1svi!2s!4v1679988049746!5m2!1svi!2s",
    
};
